<template>
  <div class="print-box p-1 tem">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td>Quy cách</td>
        <td>
          <b v-if="manufacture.productSpecify">{{
            manufacture.productSpecify.name
          }}</b>
        </td>
        <td>mm</td>
        <td colspan="2">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Mã màu</td>
        <td colspan="2">{{ manufacture.colorCode1 }}</td>
        <td>
          <span v-if="isOdd">
            <base-input
              v-if="isEdit"
              placeholder="SL/Cuộn"
              v-model="Tem.slco"
              :mask="'number'"
            ></base-input>
            <span v-else>
              <span v-if="quantityOdd">{{ quantityOdd }}</span>
              <span v-else>{{ Tem.slco }}</span>
            </span>
          </span>
          <span v-else
            ><b>{{ Tem.slc }}</b></span
          >
        </td>
        <td>{{ manufacture.unit }}</td>
      </tr>
      <tr v-if="code">
        <td colspan="5">
          <barcode v-bind:value="code" height="40" width="1" fontSize="12">
            Lỗi render code
          </barcode>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
export default {
  name: "tem-loi",
  components: {
    barcode: VueBarcode
  },
  props: {
    manufacture: {},
    Tem: {},
    quantityOdd: {},
    code: {},
    isOdd: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  }
};
</script>
